var label =
webpackJsonp_name_([15],{

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(555);

__webpack_require__(420);

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(20);

var _inherits3 = _interopRequireDefault(_inherits2);

var _label = __webpack_require__(421);

var _label2 = _interopRequireDefault(_label);

var _publicApi = __webpack_require__(6);

var _publicApi2 = _interopRequireDefault(_publicApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loader = {
    name: 'us:label',

    extends: 'viewport',

    constructor: function (_Label) {
        (0, _inherits3.default)(HackLabel, _Label);

        function HackLabel(uScope, viewport) {
            (0, _classCallCheck3.default)(this, HackLabel);

            // Polluting the viewport is a temp hack till I find a better way of handling however this is used.
            var _this = (0, _possibleConstructorReturn3.default)(this, (HackLabel.__proto__ || Object.getPrototypeOf(HackLabel)).call(this, uScope, viewport));

            viewport.label = _this;
            return _this;
        }

        return HackLabel;
    }(_label2.default)
};

_publicApi2.default.plugins.register(loader);

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Label;

var _lbsPiDash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lbsPiDash);

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _helpers = __webpack_require__(4);

var _publicApi = __webpack_require__(6);

var _publicApi2 = _interopRequireDefault(_publicApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var defaults = {
    layout: { 'divClass': _defines2.default.clsDIVLABEL, 'precinct': 'TR', 'order': 1 }
};

function Label(uScope, viewport) {
    var self = this;
    var isLoaded = false; // label has been loaded

    var jVpDiv = viewport.vpDivGet('outer');
    var jLabelDiv;

    var angleDeg = 0; // the label's angle of rotation in degrees

    var prefVisibleDef = true; // label visibility preference default
    var prefRotationDef = 0; // label rotation default

    var navModesImHiddenIn = {}; // what navigation modes not to display the label

    var layout = _.clone(defaults.layout); // label layout info, clone the global set so I can modify it
    var reLayout = viewport.overLayout.refreshPrecinct;

    //............................................ construct_ local
    var construct_ = function construct_() {

        navModesImHiddenIn[_defines2.default.eNavModes.nmRasterScan] = true; // hide label in rasterscan mode
        _defines2.default.setAnnotNavModes(navModesImHiddenIn); // hide label when drawing any annotation

        // if the label has been disabled or the user does not have rights to view it, don't load it
        if (viewport.hasALabel() == false) return; // if this image has no label, return
        if (uScope.canViewLabel() == false) return;

        load_(); // load the label image
        return;

        //..................................................
        // closure functions
        //............................................ load_()
        //    This function loads the label image div and, when the image loaded,
        //    calls into the layout manager to position it according to its layout settings.
        function load_() {
            if (jLabelDiv) return; // if this viewport already has a label div, return

            // first create an offscreen div that will contain the Label img and add it to the vp
            jLabelDiv = $('<div/>', { // build the div tag that contains the img tag
                'class': _defines2.default.clsDIVLABEL + ' ' + _defines2.default.clsOVERLAY,
                'title': 'Image Label:\r Click to rotate the image label.\r Save rotation preference in the settings panel.', // tooltip
                css: { 'left': _defines2.default.kDEF_TILE_POS_PX, 'top': _defines2.default.kDEF_TILE_POS_PX }
            });
            jVpDiv.append(jLabelDiv); // place the label div in the vp
            jLabelDiv = jVpDiv.find('.' + _defines2.default.clsDIVLABEL);

            // next build the image tag and load the label image
            // BROWSER_FIX_HERE: the label is requested as a square so FF rotation leaves space in layout manger who doesn't know if it is rotated

            var sLabelImgSrc = viewport.urlBuilder.label(_defines2.default.labelSpecs.width, _defines2.default.labelSpecs.width);

            var jImg = $('<img/>', { // place the labelImg in the DOM's label div
                load: function load(e) {
                    // check that this viewport's imageId === this image source's imageId
                    var srcId = (0, _helpers.getImageIdFromSrcAttr)(e.currentTarget); // format "@2"
                    if (viewport.getImageId() !== srcId) {
                        // if they don't match, do not load this thumbnaail (async return from another image!)
                        // ('...label:load: vpDiv id=' + viewport.getImageId() + '  srcId=' + srcId + ' - skipping load!!'); // eslint-disable-line no-undef
                        return;
                    }
                    if (isLoaded == true) {
                        // don't load the same label multiple times (happens when VIL reopens same image)
                        // ('...label:load: Label image for (' + viewport.getImageId() + ') received again!!'); // eslint-disable-line no-undef
                        return;
                    }
                    isLoaded = true;

                    jLabelDiv.append(e.currentTarget); // place the labelImg in the DOM's label div in the viewport
                    viewport.overLayout.add(layout); // and call into layout with parms to place the div

                    rotate_(uScope.prefGet('labelRotation'), 'absolute');
                    self.show(prefVisibleDef);
                },
                error: function error(e) {
                    // ('label:load: error'); // eslint-disable-line no-undef
                },
                'class': _defines2.default.clsIMGLABEL,
                'src': sLabelImgSrc,
                'alt': ''
            });
            bindEvents_(); // add event handlers
        }
        //............................................ bindEvents_()
        // bindEvents_ - This function adds the  label event handlers.
        //
        //    Note that by using the same namespace as the viewport when the
        //    viewport removes its events by namespace, these are also removed.

        function bindEvents_() {
            var namespace = viewport.eventNameSpaceGet();

            // show/hide label on mode change
            $(_defines2.default.idHashROOT).on(_defines2.default.evMODECHANGE + namespace, function (e, parms) {
                // show is true if this is the image selected and not in a mode that I'm supposed to hide during
                var bshow = viewport.getImageIdx() == uScope.getSelImageIdx() && navModesImHiddenIn[parms.navMode] == undefined ? true : false;
                self.show(bshow);
            });
            // show/hide label if image is selected/not-selected
            $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGESELECTED + namespace, function (e, parms) {
                if (viewport.sampleTypeIsControl() == true) self.show(true);else self.show(parms.uScopeIdx == viewport.getImageIdx());
            });

            // user preference update
            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFSREADY + namespace, function (e, parms) {
                self.show(uScope.prefGet(_defines2.default.clsDIVLABEL));
                rotate_(uScope.prefGet('labelRotation'), 'absolute');
            });
            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFSET + namespace, function (e, parms) {
                // parms: {className: STR, value: bool}
                if (parms.className == _defines2.default.clsDIVLABEL) {
                    self.show(parms.value);
                    rotate_(uScope.prefGet('labelRotation'), 'absolute');
                }
            });
            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFDEFAULTVISIBLE + namespace, function (e, parms) {
                uScope.prefSet(_defines2.default.clsDIVLABEL, prefVisibleDef);
            });
            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFDEFAULTLABELROT + namespace, function (e, parms) {
                uScope.prefSet('labelRotation', prefRotationDef);
            });

            // prevent dblclick on label causing double click zoom on viewport
            // capture mousedown so event does not propigate to viewport and close open dialogs
            jLabelDiv.on('mousedown' + namespace + ' dblclick' + namespace, function (e) {
                return false;
            });

            jLabelDiv.on('click' + namespace, function (e) {
                viewport.setImageSelected(); // inform uScope that this image is in focus
                rotate_(90, 'relative');
                // TODO: publish this event on the viewport and let it bubble up to the vil.
                _publicApi2.default.events.trigger('uscope:label:rotate', angleDeg);
                e.preventDefault();
                return false;
            });
        }
        //..................................................
    };

    //............................................ get/set() public
    this.getViewAngle = function () {
        return angleDeg;
    };

    //............................................ show() public
    this.show = function (show) {
        if (isLoaded == false) return;

        // prevent show if preference is not to show
        if (uScope.prefGet(_defines2.default.clsDIVLABEL) == false) jLabelDiv.hide();else if (show == true) jLabelDiv.show();else jLabelDiv.hide();

        reLayout(layout.precinct); // layout just this overlay's precinct
    };

    //............................................ rotate_() local
    //    This function rotates the label.
    //    parameters:
    //        nDegrees    : angle in degrees
    //        relOrAbs    : { "relative or "absolute" }
    //                        if "relative" the label is rotated the current angle + nDegrees clockwise
    //                        if "absolute" the label is rotated nDegrees clockwise
    //    returns:    none
    //    limitations - only 90 degree angles are implemented
    //
    //    improvements:
    //        - would it be better to have a circular array of rotation classes rather than build the string?
    //        - when tiled images are implemented this will have to select the proper image
    //
    // Label Rotation: http://answers.oreilly.com/topic/1004-how-to-rotate-an-image-with-css/
    //    http://www.communitymx.com/content/article.cfm?cid=6DA05
    //
    var rotate_ = function rotate_(nDegrees, relOrAbs) {
        if (jLabelDiv == undefined || (0, _helpers.isNumber)(nDegrees) == false) return;
        if (_defines2.default.ENABLELABEL == false || isLoaded == false) return;
        if (nDegrees % 90 != 0) nDegrees = 0;

        var curRotationClass = _defines2.default.ROTATE + angleDeg;

        var newRotation = relOrAbs == 'relative' ? (+angleDeg + nDegrees) % 360 : +nDegrees;
        var newRotationClass = _defines2.default.ROTATE + newRotation;

        jLabelDiv.removeClass(curRotationClass).addClass(newRotationClass);
        angleDeg = newRotation;
    };
    //............................................ construction
    construct_();
}
module.exports = exports['default'];

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(336);


/***/ })

},[622]);